import cx from 'classnames';
import { HTMLProps } from 'react';

import { LocalHeroIcon } from './LocalHeroIcon';
import style from './LocalHeroMark.module.css';

type Props = HTMLProps<HTMLSpanElement>;

export function LocalHeroMark(props: Props) {
    const { className, ...rest } = props;

    return (
        <span className={cx([style.mark, className])} {...rest}>
            <LocalHeroIcon width="20" height="20" />
        </span>
    );
}
